import { createListenerMiddleware } from '@reduxjs/toolkit';
import { addMiddleware } from 'redux-dynamic-middlewares';
import matchesMobileUserAgent from 'modules/deviceCapabilities';
import { LocationType, searchParametersActions } from 'features/searchResultsFacets';

const isMobileDevice = matchesMobileUserAgent();
const searchBarContainer = isMobileDevice
  ? document.querySelector('[data-search-bar-container-mobile]')
  : document.querySelector('[data-search-bar-container-desktop]');
const typeaheadInput = searchBarContainer.querySelector('[data-search-input]');
const listenerMiddleware = createListenerMiddleware();

/**
 * Using the listener middleware to listen to the fetchLocations action.
 * This listener is in charge of cleaning the typeahead field when the fetchLocations action is dispatched.
 */
listenerMiddleware.startListening({
  actionCreator: searchParametersActions.fetchLocations,
  effect: (action) => {
    if (action.payload?.locationType !== LocationType.RectangularArea.toString()) {
      return;
    }

    typeaheadInput.value = '';
  },
});
addMiddleware(listenerMiddleware.middleware);
